// extracted by css-extract-rspack-plugin
export default {"component":"TextEditor-module__component___d7f5F","linkDecorator":"TextEditor-module__linkDecorator___HIVfv","linkDecoratorAnchor":"TextEditor-module__linkDecoratorAnchor___r_5rE"};